import React from "react";
import { FormNumericInput, FormSelect, FormCheckbox } from "components/form-fields";
import { GridLayout } from "components/grid";

export function EditDataRetentionForm({
    isLoading,
    revertToBaseline,
    documentRetentionRow,
    setDocumentRetentionRow,
    autoFrequencyTypeOptionList,
    setRevertToBaseline,
}) {

    return (
        <GridLayout numberOfColumns={2} gap={20} className="custom-grid-class">
            <div>
                <div className="spacer-bottom-small"><strong>Upload</strong></div>
                <div>{documentRetentionRow.dataRetentionName}</div>
            </div>
            <div>
                {!documentRetentionRow.isUsingBaseline && (
                    <>
                        <div className="spacer-bottom-small"><strong>Baseline Data Retention Period</strong></div>
                        <div>{`${documentRetentionRow.baselinePeriod.value} ${documentRetentionRow.baselinePeriod.type}`}</div>
                    </>
                )}
            </div>
            <div style={{ gridColumn: "span 2" }}>
                <div className="spacer-bottom-small"><strong>New data retention period</strong></div>
                <div className="form-row field-combination">
                    <FormNumericInput
                        disabled={isLoading || revertToBaseline}
                        disabledInput={isLoading || revertToBaseline}
                        min={1}
                        max={999999}
                        selectedValue={documentRetentionRow.period.value}
                        onValueChange={(value) =>
                            setDocumentRetentionRow((prev) => ({
                                ...prev,
                                period: { ...prev.period, value },
                            }))
                        }
                        loading={isLoading}
                    />
                    <FormSelect
                        disabled={isLoading || revertToBaseline}
                        items={autoFrequencyTypeOptionList}
                        selectedValue={documentRetentionRow.period.type}
                        onItemSelect={(item) =>
                            setDocumentRetentionRow((prev) => ({
                                ...prev,
                                period: { ...prev.period, type: item.id },
                            }))
                        }
                        loading={isLoading}
                    />
                </div>
                {!documentRetentionRow.isUsingBaseline && (
                    <div>
                        <FormCheckbox
                            label="Revert to baseline retention period"
                            onChange={() => {
                                setRevertToBaseline((prevRevert) => {
                                    const newRevertState = !prevRevert;
                                    setDocumentRetentionRow((prevRow) => ({
                                        ...prevRow,
                                        period: newRevertState
                                            ? { ...prevRow.baselinePeriod }
                                            : { ...prevRow.originalPeriod },
                                    }));
                                    return newRevertState;
                                });
                            }}
                            checked={revertToBaseline}
                        />
                    </div>
                )}
            </div>
        </GridLayout>
    );
};